const init = () => {
	// Grab all faqs excluding the first one
	const faqs = document.querySelectorAll('.faq:not(:first-child) .js-faq');

	if (typeof(faqs) !== 'undefined') {
		faqs.forEach(faq => faq.classList.remove('show'));
	}
};

init();
